import gql from 'graphql-tag';

const loginMutation = gql`
  mutation authenticate($email: String!, $password: String!) {
    authenticate(input: { temail: $email, password: $password }) {
      jwt
    }
  }
`;

export { loginMutation };
